module.exports = __webpack_public_path__ + "img/svg/upload.4080dabe5c0c71c48c3f310451e0735f.svg";